import * as React from 'react';

interface Props {
  closeError: Function;
}

const errorNotification = (props: Props) => {
  return (
    <article className="message is-danger fadeInObject">
      <div className="message-header">
        <p>経路または金額にエラーが含まれています</p>
        <button
          className="delete"
          aria-label="delete"
          onClick={e => props.closeError()}
        />
      </div>
      <div className="message-body">
        経路または金額に Failure
        が表示されている場合、そのレコードはCSV出力の対象外になっています。
        <br />
        出力したい場合はFailureを解決してから再度CSV Download
        ボタンを押下してください
      </div>
    </article>
  );
};

export default errorNotification;



// WEBPACK FOOTER //
// ./src/components/ErrorNotification.tsx